// extracted by mini-css-extract-plugin
var _1 = "DocFlowMappingWidgetResult-moduleitems__Au9aC";
export { _1 as "items" }
